<template>
  <template-protip-banner
    v-if="shouldShowProTip"
    :bannerCustomClass="$style.applicationProtipBanner"
  >
    <div :class="$style.bannerBody">
      <div>{{ settings.summary }}</div>
      <ul :class="$style.bullets">
        <li
          v-for="(bullet, index) in settings.bullets"
          :key="index"
        >
          {{ bullet }}
        </li>
      </ul>
    </div>
    <div :class="$style.actionButtons">
      <FlatActionButton
        :action="handleCheckItOut"
        :class="$style.checkItOutButton"
        text="Check it out"
      />
      <a
        :class="$style.learnMoreLink"
        :href="settings.kbArticleUrl"
        rel="noopener noreferrer"
        target="_blank"
        @click="handleLearnMore"
      >
        learn more
      </a>
    </div>
  </template-protip-banner>
</template>

<script>
import {
  ItemTypeConsts,
  StoreModelMap,
  StoreModuleMap,
} from 'client/util/Constants';
import { applicationModelNames } from 'client/util/Constants/ApplicationConstants';
import { mapActions, mapGetters, mapState } from 'vuex';
import ApplicationProtipBannerSettings from 'client/applications/ApplicationProtipBanner/ApplicationProtipBannerSettings';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';
import TemplateProtipBanner from 'client/components/ProtipBanner/TemplateProtipBanner.vue';
import Util from 'client/util/Util';

const applicationCollection = StoreModuleMap[ItemTypeConsts.application];
const applicationModel = StoreModelMap[ItemTypeConsts.application];
const directoryCollection = StoreModuleMap[ItemTypeConsts.directory];

export default {
  name: 'ApplicationProtipBanner',

  components: {
    FlatActionButton,
    TemplateProtipBanner,
  },

  computed: {
    ...mapGetters(applicationCollection, {
      configuredApplications: 'getCollection',
    }),
    ...mapGetters(directoryCollection, {
      configuredCloudDirectories: 'getCollection',
    }),
    ...mapState(applicationModel, [
      'item',
    ]),

    isApplicationConfigured() {
      return this.configuredApplications.some(
        application => application.name === this.getApplicationName(),
      );
    },

    isApplicationRelatedCloudDirectoryConfigured() {
      if (this.isCurrentModelFor(applicationModelNames.OFFICE365)) {
        return this.isCloudDirectoryConfigured(ItemTypeConsts.office365);
      }
      if (this.isCurrentModelFor(applicationModelNames.GSUITE)) {
        return this.isCloudDirectoryConfigured(ItemTypeConsts.gSuite);
      }
      return false;
    },

    settings() {
      return ApplicationProtipBannerSettings[this.getApplicationName()];
    },

    shouldShowProTip() {
      return this.settings
        && !this.isApplicationConfigured
        && !this.isApplicationRelatedCloudDirectoryConfigured;
    },
  },

  created() {
    this.fetchCloudConfiguredDirectories();
  },

  methods: {
    ...mapActions(directoryCollection, {
      fetchCloudConfiguredDirectories: 'fetchCollection',
    }),

    getApplicationName() {
      return this.item.name;
    },

    getEventSegmentPayload() {
      return {
        application: this.getApplicationName(),
      };
    },

    handleCheckItOut() {
      EventHelper.triggerApplicationBannerCheckItOutButtonClicked(this.getEventSegmentPayload());
      Util.redirect(this.settings.cloudDirectoryUrl);
    },

    handleLearnMore() {
      EventHelper.triggerApplicationBannerLearnMoreButtonClicked(this.getEventSegmentPayload());
    },

    isCloudDirectoryConfigured(cloudDirectoryType) {
      return this.configuredCloudDirectories.some(
        directory => directory.type === cloudDirectoryType,
      );
    },

    isCurrentModelFor(applicationModelName) {
      return this.getApplicationName() === applicationModelName;
    },

  },
};
</script>

<style module>
.applicationProtipBanner {
  padding: 11px;
}

.bannerBody {
  font-size: 13px;
  padding: 10px;
}

.bullets.bullets {
  list-style-type: none;
  margin: 10px 0;
  padding: 0;
}

.bullets > li::before {
  content: "-";
  text-indent: -2px;
}

.bullets > li:not(:first-child) {
  margin-top: 3px;
}

.actionButtons {
  align-items: center;
  display: flex;
  justify-content: space-around;
}

.checkItOutButton {
  padding: 8px;
}

.learnMoreLink.learnMoreLink {
  font-size: 14px;
}

</style>
